module.exports = __webpack_public_path__ + "img/splashLogo.d76973f9.png";